import { useAppDispatch, useAppSelector } from 'flow/hooks/useRedux';
import { CallRecordKey } from 'flow/types/EntityKeys';
import { removeVoiceMessage } from 'flow/actions/extension-actions';
import { selectOwnExtensionKey } from 'flow/selectors/ExtensionSelectors';
import { selectCallRecordVoiceMessageUniqueId } from 'flow/selectors/call-records-selectors';
import useAppContext from 'flow/hooks/useAppContext';
import Icon from 'flow/components/ui-components/Icon';
import MenuItem from 'flow/components/ui-components/MenuItem';

interface Props {
    callRecordKey: CallRecordKey;
}

const MenuItemDeleteVoicemail = ({ callRecordKey }: Props) => {
    const { i18next } = useAppContext();
    const dispatch = useAppDispatch();
    const ownExtensionKey = useAppSelector(selectOwnExtensionKey);
    const voiceMessageUniqueId = useAppSelector((state) =>
        selectCallRecordVoiceMessageUniqueId(state, callRecordKey),
    );

    if (!voiceMessageUniqueId) return null;

    return (
        <MenuItem
            onClick={() =>
                dispatch(
                    removeVoiceMessage(
                        ownExtensionKey,
                        voiceMessageUniqueId,
                        callRecordKey,
                    ),
                )
            }
        >
            <div className="text-red flex items-center gap-x-2">
                <Icon iconKey="delete" />
                {i18next.t('call.voicemail.delete')}
            </div>
        </MenuItem>
    );
};

export default MenuItemDeleteVoicemail;
